export default __webpack_public_path__ + "static/media/doggo.8d9a5dca.jpg";